import { render, staticRenderFns } from "./AccessControlView.vue?vue&type=template&id=4ec1f3b7&"
import script from "./AccessControlView.vue?vue&type=script&lang=js&"
export * from "./AccessControlView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports